const lng = {
  de: {
    BUY: 'In den Warenkorb',
    PDP: 'Produktdetails ansehen',
    DISCLAIMER: 'Preise inkl. gesetzlicher Umsatzsteuer und Versandkosten',
    UVP: 'UVP',
    NOTSELLABLE:
      'Deine Auswahl ist leider nicht verfügbar. Wir haben daher die ähnlichste Variante gewählt.',
    DELIVERY: 'Lieferzeit',
    VALUE_PACK: 'Preisersparnis im Set gegenüber Einzelkauf',
    RECOMMENDATIONS_HEADLINE: 'Das könnte dir auch gefallen'
  },
  fr: {
    BUY: 'Ajouter au panier',
    PDP: 'Voir la fiche produit',
    DISCLAIMER: 'Tous les prix incluent la TVA et les frais de livraison',
    UVP: 'PVC',
    NOTSELLABLE:
      "Votre sélection n'est malheureusement pas disponible. Voici le produit le plus similaire.",
    DELIVERY: 'Livré sous',
    VALUE_PACK: "Par rapport à un achat à l'unité, vous économisez",
    RECOMMENDATIONS_HEADLINE: 'Vous aimerez aussi...'
  },
  it: {
    BUY: 'Nel carrello',
    PDP: 'Vai alla scheda prodotto',
    DISCLAIMER:
      'Tutti i prezzi sono in euro (€) e includono Iva e spese di consegna',
    UVP: '',
    NOTSELLABLE:
      "ll prodotto da te selezionato non e' al momento disponibile. Abbiamo selezionato per te i prodotti piu' simili.",
    DELIVERY: 'Consegna',
    VALUE_PACK: 'Acquistando in set invece che per unità, risparmi',
    RECOMMENDATIONS_HEADLINE: 'Potrebbe piacerti anche questo'
  },
  nl: {
    BUY: 'In de winkelwagen',
    PDP: 'Bekijk productgegevens',
    DISCLAIMER: "Alle prijzen in euro's (€), inclusief BTW en verzendkosten",
    UVP: 'Adviesprijs',
    NOTSELLABLE:
      'Je keuze is helaas niet beschikbaar. We hebben de variant uitgekozen die er het meeste op lijkt.',
    DELIVERY: 'Levertijd',
    VALUE_PACK: 'Als je een set i.p.v. een enkel artikel koopt, bespaar je',
    RECOMMENDATIONS_HEADLINE: 'Dit vind je misschien ook leuk'
  }
};

export const lngprovider = lngcode => {
  const code = lngcode.split('_')[0];
  return lng[code] ? lng[code] : false;
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/constants/languages.js
 **/